<template lang="pug">
  .qmod-component
    .qmod-component-header
      h1.qmod-heading.qmod-h1(v-if="$slots.ComponentTitle")
        <!-- @slot Pass in a ComponentTitle -->
        slot(name="ComponentTitle")
      .qmod-heading-right(v-if="$slots.ComponentTitleButtons")
        <!-- @slot Use this slot ComponentTitleButtons -->
        slot(name="ComponentTitleButtons")
    .qmod-component-content
      <!-- @slot Use this slot Default -->
      slot Default Slot
</template>
<script>
/* eslint-disable */
/**
 * Use this wrapper in every component build.
 * Includes base styles for layouts.
 */
export default {
  name: "BaseWrapper",
  props: {}
};
</script>

<style lang="stylus">
{$preFix}
  &-loading
    opacity 0.4
  &-component
    display block
    color $fc
    font-family $qmod-font-family
    font-size $fs
    letter-spacing normal
    background-color #FFFFFF
  &-h1
    font-size $fs + 4
    font-weight 500
  &-h2
    font-size $fs + 2
    font-weight 500
  &-h3
    font-size $fs + 1
    font-weight 500
  &-component-header
    border-bottom 1px solid $qmod-blue
    &:after
      content ''
      display table
      clear both
    {$preFix}-heading
      padding 5px 0
      display inline-block
      margin 0
    {$preFix}-heading-right
      float right
</style>
